<template>
  <ReleaseSampleV2 v-if="processingSample || failedSample" :sample="sample"></ReleaseSampleV2>
<v-menu v-else>
  <template v-slot:activator="{on}">
    <v-btn v-on="on" small tile color="primary">Release Options</v-btn>
  </template>
  <v-list>
    <v-list-item @click="sendToResultsEmailer">
      <v-list-item-title>Send To Emailer</v-list-item-title>
    </v-list-item>
    <v-list-item @click="$store.dispatch('ReleaseSampleStore/releaseSample', sample.uuid)">Release</v-list-item>
  </v-list>
</v-menu>
</template>

<script>
export default {
  name: "ReleaseIndividual",
  components: {
    ReleaseSampleV2: () => import('@/views/ReleaseV2/components/ReleaseSampleV2'),
  },
  props: {
    sample: {
      required: true,
    }
  },
  data: () => ({
  }),
  mounted() {
    this.$store.dispatch('ReleaseSampleStore/listenToProcessing');
  },
  computed: {
    processingSample() {
      return this.sample.uuid in this.$store.state.ReleaseSampleStore.samplesProcessing
        ? this.$store.state.ReleaseSampleStore.samplesProcessing[this.sample.uuid]
        : false;
    },
    failedSample() {
      return this.sample.uuid in this.$store.state.ReleaseSampleStore.samplesFailed
        ? this.$store.state.ReleaseSampleStore.samplesFailed[this.sample.uuid]
        : false;
    },

  },
  methods: {
    async sendToResultsEmailer(){
      await this.$firestore.collection('release_sample').doc(this.sample.uuid).update({
        email_sent: false,
      })
      await this.$store.dispatch("showSuccess", "Result sent to Emailer")
    },
  },
  beforeDestroy(){
    this.$store.dispatch('ReleaseSampleStore/resetDataAndStopListeners');
  }
}
</script>

<style scoped>

</style>
